import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    title: 'Consigue los ingredientes',
    desc: 'Usa mi guía de compras rápida en tu tienda local.'
  }, {
    title: 'Sigue el Método',
    desc: 'Ejecuta el tostado y el relleno siguiendo las proporciones exactas.'
  }, {
    title: 'Impresiona',
    desc: 'Sigue el manual de decoración y entrega un regalo de $100 hecho por ti.'
  }];
  return <section className="py-24 px-6 bg-dark-lighter" data-id="element-91">
      <div className="max-w-4xl mx-auto" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-93">
          <h2 className="font-serif text-3xl md:text-4xl text-cream mb-4" data-id="element-94">
            Cómo funciona
          </h2>
          <p className="font-sans text-cream-muted" data-id="element-95">
            Tu camino hacia el pastel perfecto en 3 simples pasos
          </p>
        </motion.div>

        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-8 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-gold/20 before:to-transparent" data-id="element-96">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} viewport={{
          once: true
        }} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-97">
              <div className="flex items-center justify-center w-16 h-16 rounded-full border-2 border-gold bg-dark text-gold font-serif text-2xl font-bold shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-[0_0_15px_rgba(197,165,90,0.2)] z-10" data-id="element-98">
                {index + 1}
              </div>
              <div className="w-[calc(100%-5rem)] md:w-[calc(50%-3rem)] bg-dark-card p-6 rounded-lg border border-white/5 hover:border-gold/30 transition-colors" data-id="element-99">
                <h3 className="font-serif text-xl text-cream mb-2" data-id="element-100">
                  {step.title}
                </h3>
                <p className="font-sans text-cream-muted text-sm" data-id="element-101">
                  {step.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}